































import { Component, Prop, Vue } from 'vue-property-decorator';

import { Product } from '@/store/modules/lib';

@Component
export default class ShBadgeItem extends Vue {

  // @Prop({ type: Boolean, default: false }) protected noBorder!: boolean;
  // @Prop({ type: Boolean, default: false }) protected isSelected!: boolean;
  // @Prop({ type: Object, default: {} }) protected product!: Product;

  // protected selected() {
  //   this.$emit('selected', this.product._id);
  // }

  // protected remove() {
  //   this.$emit('remove', this.product._id);
  // }

  // protected edit() {
  //   this.$emit('edit', this.product._id);
  // }

}

